import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppFloatingConfigurator } from '../../layout/component/app.floatingconfigurator';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, AppFloatingConfigurator, TranslateModule],
    template: ` <app-floating-configurator />
        <div class="flex items-center justify-center min-h-screen overflow-hidden">
            <div class="flex flex-col items-center justify-center">
                <img src="assets/logo.svg" alt="KarteX Logo" class="mb-8 mx-auto logo-theme-adaptive" style="height: 64px; width: auto" data-testid="notfound-logo" />
                <div style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, color-mix(in srgb, var(--primary-color), transparent 60%) 10%, var(--surface-ground) 30%)">
                    <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center" style="border-radius: 53px">
                        <span class="text-primary font-bold text-3xl">404</span>
                        <h1 class="text-surface-900 dark:text-surface-0 font-bold text-3xl lg:text-5xl mb-2 text-center" data-testid="notfound-title">{{ 'COMMON.NOT_FOUND_PAGE.TITLE' | translate }}</h1>
                        <p class="text-surface-600 dark:text-surface-200 mb-8 text-center max-w-md" data-testid="notfound-message">{{ 'COMMON.NOT_FOUND_PAGE.MESSAGE' | translate }}</p>
                        <div class="flex flex-col sm:flex-row gap-2">
                            <a class="p-button p-component justify-center" routerLink="/" data-testid="notfound-go-panel"> <i class="pi pi-home mr-2" aria-hidden="true"></i>{{ 'COMMON.NOT_FOUND_PAGE.GO_PANEL' | translate }} </a>
                            <button type="button" class="p-button p-component p-button-outlined justify-center" (click)="back()" data-testid="notfound-back">
                                <i class="pi pi-arrow-left mr-2" aria-hidden="true"></i>{{ 'COMMON.NOT_FOUND_PAGE.GO_BACK' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
})
export class Notfound {
    private readonly location = inject(Location);

    back(): void {
        this.location.back();
    }
}
